import { render, staticRenderFns } from "./DokmanComponentPruefungPruefung.vue?vue&type=template&id=79f858e0&scoped=true"
import script from "./DokmanComponentPruefungPruefung.vue?vue&type=script&lang=js"
export * from "./DokmanComponentPruefungPruefung.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentPruefungPruefung.vue?vue&type=style&index=0&id=79f858e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f858e0",
  null
  
)

export default component.exports